// extracted by mini-css-extract-plugin
export default {"news_box":"index_news_box_-Qno6 clearfix","box_r":"index_box_r_9YIxw","d_box":"index_d_box_9ZRc4"};